export default __webpack_public_path__ + "static/media/duck.85b093b2.jpg";